<div class="content-page">
  <div class="container container-sm">
    <div class="page-header">
      <span class="section-tag">FAQ</span>
      <h1 class="page-title">Frequently asked questions</h1>
      <p class="page-subtitle">Everything you need to know about URL indexing and our service.</p>
    </div>

    <div class="search-bar">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
      <input type="text" placeholder="Search questions..." [(ngModel)]="searchQuery" />
    </div>

    <div class="faq-categories">
      <button class="category-btn" [class.active]="selectedCategory === ''" (click)="selectedCategory = ''">All</button>
      <button class="category-btn" [class.active]="selectedCategory === 'general'" (click)="selectedCategory = 'general'">General</button>
      <button class="category-btn" [class.active]="selectedCategory === 'billing'" (click)="selectedCategory = 'billing'">Billing</button>
      <button class="category-btn" [class.active]="selectedCategory === 'technical'" (click)="selectedCategory = 'technical'">Technical</button>
      <button class="category-btn" [class.active]="selectedCategory === 'api'" (click)="selectedCategory = 'api'">API</button>
    </div>

    <div class="faq-list">
      <div class="faq-item" *ngFor="let faq of filteredFaqs" [class.open]="faq.open">
        <button class="faq-trigger" (click)="toggleFaq(faq)">
          <div>
            <span class="faq-category-tag" *ngIf="faq.category">{{ faq.category }}</span>
            <h3>{{ faq.question }}</h3>
          </div>
          <svg class="faq-chevron" [class.rotated]="faq.open" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
        </button>
        <div class="faq-content" *ngIf="faq.open">
          <p>{{ faq.answer }}</p>
        </div>
      </div>
    </div>

    <div class="help-cta">
      <h3>Still have questions?</h3>
      <p>Our support team responds within hours.</p>
      <a routerLink="/contact-us" class="btn btn-primary">Contact support</a>
    </div>
  </div>
</div>
